import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import { connect } from 'react-redux';
import { onChangeLoginForm } from '../../../ac/onChangeLoginForm';
import { onSignIn } from '../../../ac/onSignIn';
import { authFormInputs } from '../../../constants/variables';
import { useSpinner } from '../../../hooks/useSpinner';
import { ButtonWithSpinner } from '../../Buttons/ButtonWithSpinner';
import { LoginFormInput } from '../LoginFormInput';
import styles from '../LoginForms.module.css';

const MainLoginFormComponent = ({
    loginForm,
    onChangeLoginForm,
    onSignIn,
}) => {
    const [ isSendingRequest, onSubmit ] = useSpinner(async e => {
        e.preventDefault();
        await onSignIn();
    });
    return (
        <form
            className={styles.authForm}
            onSubmit={onSubmit}
        >
            {
                authFormInputs.map(({ id, label, type }) => (
                    <LoginFormInput
                        key={id}
                        id={id}
                        type={type}
                        onChange={onChangeLoginForm}
                        value={loginForm[id]}
                    >
                        {i18n._(label)}
                    </LoginFormInput>
                ))
            }
            <ButtonWithSpinner
                type='submit'
                isLoading={isSendingRequest}
                className={styles.signInButton}
            >
                {t`Войти`}
            </ButtonWithSpinner>
        </form>
    );
};
const mapStateToProps = ({ loginForm }) => ({ loginForm });
export const MainLoginForm = connect(mapStateToProps, {
    onChangeLoginForm, onSignIn,
})(MainLoginFormComponent);
